export const CURRENT_MANAGER_CREATE      = 'CURRENT_MANAGER_CREATE';
export const CURRENT_MANAGER_CREATE_DONE = 'CURRENT_MANAGER_CREATE_DONE';

export const CURRENT_MANAGER_UPDATE      = 'CURRENT_MANAGER_UPDATE';
export const CURRENT_MANAGER_UPDATE_DONE = 'CURRENT_MANAGER_UPDATE_DONE';

export const CURRENT_MANAGER_VALIDATE      = 'CURRENT_MANAGER_VALIDATE';
export const CURRENT_MANAGER_VALIDATE_DONE = 'CURRENT_MANAGER_VALIDATE_DONE';

export const INFORM_PREMIUM_FOLLOWES = 'INFORM_PREMIUM_FOLLOWES';
export const INFORM_PREMIUM_FOLLOWES_DONE = 'INFORM_PREMIUM_FOLLOWES_DONE';



// WEBPACK FOOTER //
// ./app/constants/currentManagerTypes.js